const Company = () => {
  return <div>Company</div>
}

export default Company
